var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDiagonal = function SvgArrowDiagonal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191F2E",
    fillRule: "evenodd",
    d: "M13.5.563A.56.56 0 0 0 12.938 0h-6.75a.563.563 0 0 0 0 1.125h5.392L.165 12.54a.562.562 0 1 0 .795.795L12.375 1.921v5.392a.562.562 0 1 0 1.125 0z",
    clipRule: "evenodd"
  })));
};
export default SvgArrowDiagonal;